<div class="astrea-cart p-sm-4 p-2">
    <div class="container">

        <div class="astrea-title">
            <h1 class="mb-4">{{ 'cart.title' | translate }}</h1>
        </div>

        <mat-tab-group [selectedIndex]="currentTab" (selectedIndexChange)="handleChangeTab($event)">
            <mat-tab label="{{ 'cart.tabs.details' | translate }}">

                <div class="mat-elevation-z4" *ngIf="!loading; else astreaLoading">
                    <div *ngIf="booksMerge && booksMerge.length > 0; else withoutResults">
                        <astrea-cart-item
                            *ngFor="let b of booksMerge"
                            [bookMerge]="b"
                            (updateItem)="handleUpdateItem($event)"
                            (deleteItem)="handleDeleteItem($event)"
                        ></astrea-cart-item>
                    </div>
                </div>

                <div *ngIf="booksMerge && booksMerge.length > 0">
                    <button (click)="handleProceedToPurchase()" class="btn btn-green btn-purchase float-right mb-2" mat-button>
                        {{ isLoggedIn ? ('cart.login' | translate) : ('cart.logout' | translate) }}
                    </button>
                </div>

            </mat-tab>
            <mat-tab *ngIf="booksMerge.length > 0" label="{{ 'cart.tabs.summary' | translate }}">

                <div class="mat-elevation-z4" *ngIf="!loading; else astreaLoading">
                    <astrea-cart-summary
                        [isLoggedIn]="isLoggedIn"
                        [physicalBooks]="physicalBooks"
                        [digitalBooks]="digitalBooks"
                        [booksMerge]="booksMerge"
                        (changeTab)="handleChangeTab($event)"
                    ></astrea-cart-summary>
                </div>

            </mat-tab>
            <mat-tab *ngIf="isLoggedIn && physicalBooks.length > 0" label="{{ 'cart.tabs.physical' | translate }}">

                <div class="mat-elevation-z4" *ngIf="!loading; else astreaLoading">
                    <astrea-cart-physical
                        [setUser]="user"
                        [userInvoicing]="userInvoicing"
                        [userResidence]="userResidence"
                        [isLoggedIn]="isLoggedIn"
                        [physicalBooks]="physicalBooks"
                    ></astrea-cart-physical>
                </div>

            </mat-tab>
            <mat-tab *ngIf="isLoggedIn && digitalBooks.length > 0" label="{{ 'cart.tabs.digital' | translate }}">

                <div class="mat-elevation-z4" *ngIf="!loading; else astreaLoading">
                    <astrea-cart-digital
                        [setUser]="user"
                        [userInvoicing]="userInvoicing"
                        [userResidence]="userResidence"
                        [isLoggedIn]="isLoggedIn"
                        [digitalBooks]="digitalBooks"
                    ></astrea-cart-digital>
                </div>

            </mat-tab>
        </mat-tab-group>



        <ng-template #withoutResults>
            <div class="t-center">
                <img class="img-responsive" src="/assets/images/illustrations/Illustration-library.png" alt="Estanteria con libros.">
                <p>{{ 'cart.without' | translate }}</p>
            </div>
        </ng-template>

        <ng-template #astreaLoading>
            <astrea-loading
                [text]="'cart.loading' | translate"
            ></astrea-loading>
        </ng-template>

    </div>
</div>
